import React, {useContext} from "react";
import { NavLink } from "react-router";
import { Box, Button } from "@chakra-ui/react";
import { Dynoes } from "../../components/Dynoes";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider";
import { HelmetComponent } from "../../components/HelmetComponent";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import "../../App.scss";

export const MyDynosPage = () => {
  const {user} = useContext(PublisherAndUserContext);
  const { addBreadcrumb } = useBreadcrumbs();
  return (
    <>
      <HelmetComponent title={`MyDynos - Home - ${user.firstName} ${user.lastName}`}/>    
      <Box
        className="content"
        m="0 auto"
        minHeight="calc(100vh - 80px)"
        position="relative"
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb="5"
        >
          <Box></Box>
          <Box>
            <NavLink
              to={`/createeddoc`}
              style={{ margin: "0" }}
              onClick={() => addBreadcrumb("Create EdDoc", "/createeddoc", true)}
            >
              <Button colorScheme="blue" marginTop="20px">Create EdDoc</Button>
            </NavLink>
          </Box>
        </Box>
        <Dynoes />
      </Box>
    </>
  );
};
